import { Compute } from 'cerebral'
import { state } from 'cerebral/tags'
import controller from 'controller.js'

export default Compute(state`media.files.*`, __refresh => {
  return Object.entries(controller.getState('media.files'))
    .map(([_, file]) => file)
    .sort((a, b) => b.addedAt - a.addedAt)
})



// WEBPACK FOOTER //
// ./src/modules/Media/computed/latestFiles.js